import Breadcrumb from "../../Component/Breadcrumb";

function Disclosure() {
  return (
    <>
      <Breadcrumb>About / Disclosure</Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Disclosure</h1>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div className="dis-box">
                  <h5 className="demo-title">
                    <a
                      href="https://sjsbrlschool.edu.in/pdf/afe.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Affiliation Letter Extension
                    </a>
                  </h5>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div className="dis-box">
                  <h5 className="demo-title">
                    <a
                      href="https://sjsbrlschool.edu.in/pdf/src.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Society Renewal Certificate
                    </a>
                  </h5>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div className="dis-box">
                  <h5 className="demo-title">
                    <a
                      href="https://sjsbrlschool.edu.in/pdf/noc.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      NOC
                    </a>
                  </h5>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div className="dis-box">
                  <h5 className="demo-title">
                    <a
                      href="https://sjsbrlschool.edu.in/pdf/bsc.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Building Safety Certificate
                    </a>
                  </h5>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div className="dis-box">
                  <h5 className="demo-title">
                    <a
                      href="https://sjsbrlschool.edu.in/pdf/fsc.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Fire Safety Certificate
                    </a>
                  </h5>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div className="dis-box">
                  <h5 className="demo-title">
                    <a
                      href="https://sjsbrlschool.edu.in/pdf/rc-jr.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Recognition Certificate (UP Board Junior)
                    </a>
                  </h5>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div className="dis-box">
                  <h5 className="demo-title">
                    <a
                      href="https://sjsbrlschool.edu.in/pdf/rc-pr.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Recognition Certificate (UP Board Primary)
                    </a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Disclosure;
